module.exports = __webpack_public_path__ + "images/4a2028fd4e4a596cd8cf36ab84b9607c.jpg";